
var id = "whiteDown";
var markup = "<symbol viewBox=\"0 0 12 8\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"whiteDown\">\n    <title></title>\n    <g id=\"whiteDown_Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"whiteDown_--------——-新建活动-（STEP-02:-奖项设置）实物奖\" transform=\"translate(-1580.000000, -491.000000)\" fill=\"#616161\">\n            <g id=\"whiteDown_编组-18\" transform=\"translate(312.000000, 467.000000)\">\n                <g id=\"whiteDown_icon下抽屉\" transform=\"translate(1274.000279, 27.749903) scale(1, -1) translate(-1274.000279, -27.749903) translate(1268.000000, 24.000000)\">\n                    <path d=\"M0.290544829,0.313399447 C-0.0968482763,0.741822818 -0.0968482763,1.39400352 0.290544829,1.82246352 L5.296219,7.18817118 C5.68472919,7.60368389 6.31627115,7.60368389 6.70327969,7.18817118 L11.7089905,1.82246352 C12.0977479,1.39454376 12.0977479,0.741282585 11.7089905,0.313399447 C11.5291843,0.113888518 11.2732328,0 11.004691,0 C10.7361492,0 10.4801885,0.113888518 10.3004281,0.313399447 L5.99976765,4.92458422 L1.69910718,0.313399447 C1.51905381,0.114318874 1.26321211,0.000750832812 0.99481685,0.000750832812 C0.726412433,0.000750832812 0.47057073,0.114318874 0.290544829,0.313399447 Z\" id=\"whiteDown_Fill-1-Copy-3\" transform=\"translate(6.000279, 3.749903) rotate(180.000000) translate(-6.000279, -3.749903) \" />\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
